import {useCallback, useState} from 'react';

import {useGetRefundBanksQuery} from 'presentation/pages/private/profile/queries/useGetRefundBanksQuery';

export function useGetBanks() {
	const [open, setOpen] = useState(false);

	const {data: options, refetch, isError: fetchError, isLoading} = useGetRefundBanksQuery();

	const handleOpen = async () => {
		setOpen(true);

		if (!options) {
			await refetch();
		}
	};

	const handleClose = useCallback(async () => {
		setOpen(false);
	}, []);

	return {
		loadingList: isLoading,
		options,
		open,
		handleOpen,
		handleClose,
		fetchError,
	};
}
